import { useState } from 'react'
import { Dropdown, Checkbox, Menu } from 'antd';
export default function TableActions({ column, fixedColumnsKey, onChange }) {
  const [checkedList, setCheckedList] = useState(fixedColumnsKey)
  const checkboxChange = (value) => {
    const index = checkedList.indexOf(value)
    const list = [...checkedList]
    if (index > -1) {
      list.splice(index, 1)
    }
    else {
      list.push(value)
    }
    setCheckedList(list)
  }
  
  const menu = (
    <Menu style={{overflowY: 'auto', height: '300px'}}>
      {
        column.map(v => (
          <Menu.Item key={v.dataIndex} disabled  style={{cursor: 'pointer'}}>
            <Checkbox checked={checkedList.includes(v.dataIndex)} disabled={v.dataIndex === 'action'} onChange={() => checkboxChange(v.dataIndex)}>{v.dropdownTitle || v.title}</Checkbox>  
          </Menu.Item>
        ))
      }
    </Menu>
  );
  const onVisibleChange = (bol) => {
    if (!bol) {
      onChange(checkedList)
    }
  }
  return <div className="action-box">
    <Dropdown overlay={menu} trigger={['click']} onVisibleChange={onVisibleChange}>
      <span style={{cursor: 'pointer'}}>
        操作
        <i className="iconfont icon-houtai-xinxishezhi" style={{fontSize: '14px', marginLeft: '3px', color: '#018dd7',}}></i>
      </span>
    </Dropdown>
  </div>
}